module.exports = __webpack_public_path__ + "img/info-calculator.747b4942.svg";